import { ReportTemplateType } from "@/constants";
import { cn } from "@/lib/utils";
import { Card, CardDescription, CardTitle } from "@components/ui/card";
import { ArrowRightIcon, LucideIcon } from "lucide-react";

export type ReportTemplate = {
  id: ReportTemplateType;
  title: string;
  description: string;
  icon: LucideIcon;
  iconClassName: string;
};

type ReportTemplateProps = {
  template: ReportTemplate;
  onClick: (type: ReportTemplateType) => void;
};

export default function ReportTemplateCard({
  template,
  onClick,
}: ReportTemplateProps) {
  return (
    <Card className="px-6 text-left hover:bg-muted transition" asChild>
      <button
        type="button"
        data-testid={`new_report_${template.id}`}
        onClick={() => {
          onClick(template.id);
        }}
      >
        <div className="flex flex-row justify-between items-start gap-3">
          <template.icon
            className={cn("w-6 -translate-y-1", template.iconClassName)}
          />
          <div className="flex flex-col gap-2 flex-1">
            <CardTitle>{template.title}</CardTitle>
            <CardDescription>{template.description}</CardDescription>
          </div>
          <ArrowRightIcon className="w-4" />
        </div>
      </button>
    </Card>
  );
}
